<!-- 结算异常流程 -->
<template>
  <div class="wraper">
    <div class="title1">异常流程列表</div>
    <div class="selectWrap">
      <!-- 顶部筛选条件 -->
      <el-form
        size="mini"
        label-width="120px"
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item label="订单号">
          <el-input
            v-model.trim="form.orderId"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户运单">
          <el-input
            v-model.trim="form.outerOrderId"
            placeholder="请输入客户运单"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="车型车长" prop>
          <el-select v-model="form.vehicleLenStr" placeholder="请选择车型车长">
            <el-option label="全部" value></el-option>
            <el-option label="0.5T/1.8M" value="0.5T/1.8M"></el-option>
            <el-option label="1T/2.7M" value="1T/2.7M"></el-option>
            <el-option label="1.5T/3.5M" value="1.5T/3.5M"></el-option>
            <el-option label="1.5T/4.2M" value="1.5T/4.2M"></el-option>
            <el-option label="3T/5.2M" value="3T/5.2M"></el-option>
            <el-option label="5T/6.2M" value="5T/6.2M"></el-option>
            <el-option label="7T/7.6M" value="7T/7.6M"></el-option>
            <el-option label="14T/9.6M" value="14T/9.6M"></el-option>
            <el-option label="20T/13.5M" value="20T/13.5M"></el-option>
            <el-option label="30T/15M" value="30T/15M"></el-option>
            <el-option label="30T/16M" value="30T/16M"></el-option>
            <el-option label="30T/17.5M" value="30T/17.5M"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="承运类型" prop>
          <el-select v-model="form.carrierType" placeholder="请选择承运类型">
            <el-option label="全部" value></el-option>
            <el-option label="C端" :value="1"></el-option>
            <el-option label="B端" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="承运公司">
          <el-input
            v-model.trim="form.carrier"
            placeholder="请输入承运公司"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="司机姓名">
          <el-input
            v-model.trim="form.driverName"
            placeholder="请输入司机姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌">
          <el-input
            v-model.trim="form.vehicleSerial"
            placeholder="请输入车牌"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="计划发车时间" prop>
          <el-date-picker
            style="width:220px"
            v-model="form.planDepartTm"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="no-label" style="margin-left:100px" label>
          <el-button
            v-if="permissions.owsp_abnormalProcess_look"
            v-track="{ action: 'orderlist_query' }"
            type="danger"
            @click="onSearch"
            >查询</el-button
          >
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" v-loading="tableLoading">
      <el-table-column
        prop="name"
        label="订单结算缺失条件	"
        min-width="160"
      ></el-table-column>
      <el-table-column
        prop="typeName"
        label="异常类别"
      ></el-table-column>
      <el-table-column
        prop="customerName"
        label="客户公司名称"
        min-width="160"
      ></el-table-column>
      <el-table-column
        prop="orderId"
        label="订单号"
        min-width="130"
      ></el-table-column>
      <el-table-column
        prop="outerOrderId"
        label="客户运单号"
        min-width="170"
      ></el-table-column>
      <el-table-column
        label="找车模式"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ mapFindCar(scope.row.dispatchMode) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="订单状态"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ formatDDState(scope.row.orderState) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="线路"
        min-width="400"
      >
        <template slot-scope="scope">
          <span v-html="lineList(scope.row)"></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="planDepartTm"
        label="计划发车时间"
        min-width="150"
      ></el-table-column>
      <el-table-column label="车型车长" width="150">
        <template slot-scope="scope">
          <span
            v-html="mapVehicle(scope.row.vehicleType) + ' / ' + scope.row.vehicleLength + 'm'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="carrierInfo"
        label="承运信息"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="actualDepartTm"
        label="实际发车时间"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="actualArriveTm"
        label="实际到车时间"
        min-width="150"
      ></el-table-column>
      <el-table-column
        label="流程审批状态"
        min-width="60"
      >
        <template slot-scope="scope">
          <span>{{ formatProcessState(scope.row.state) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-button v-if="permissions.owsp_abnormalProcess_query" @click.stop="checkDetail(scope.row)" type="text" size="small">查看</el-button>
          <el-button v-if="(scope.row.state === 0 || scope.row.state === 3) && permissions.owsp_abnormalProcess_submit" @click="subApplication(scope.row)" type="text" size="small">提交申请</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="onSizeChange"
      @current-change="onCurrentChange"
      :current-page.sync="form.pageNum"
      :page-size="form.pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 详情 -->
    <el-dialog
      title="查看详情"
      :visible.sync="showDetail"
      width="80%"
      style="min-width:1100px">
      <div class="alertCont">
        <div class="partone">
          <div class="title">基础信息</div>
          <div class="itemGroup">
            <div class="item">
              <span class="label">订单号：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.orderId || ''}}</span>
            </div>
            <div class="item">
              <span class="label">流程审批状态：</span>
              <span v-if="detailData.orderInfo" class="val">{{formatProcessState(detailData.orderInfo.state) || ''}}</span>
            </div>
            <div class="item">
              <span class="label">订单结算缺失条件：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.name || ''}}</span>
            </div>
          </div>
          <div class="itemGroup">
            <div class="item">
              <span class="label">异常类别：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.typeName || ''}}</span>
            </div>
            <div class="item">
              <span class="label">客户运单号：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.outerOrderId || ''}}</span>
            </div>
            <div class="item">
              <span class="label">找车模式：</span>
              <span v-if="detailData.orderInfo" class="val">{{mapFindCar(detailData.orderInfo.dispatchMode) || ''}}</span>
            </div>
          </div>
          <div class="itemGroup">
            <div class="item">
              <span class="label">订单状态：</span>
              <span v-if="detailData.orderInfo" class="val">{{formatDDState(detailData.orderInfo.orderState) || ''}}</span>
            </div>
            <div class="item">
              <span class="label">发货地址：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.srcAddr || ''}}</span>
            </div>
            <div class="item">
              <span class="label">收货地址：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.destAddr || ''}}</span>
            </div>
          </div>
          <div class="itemGroup">
            <div class="item">
              <span class="label">计划发车时间：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.planDepartTm || ''}}</span>
            </div>
            <div class="item">
              <span class="label">车型车长：</span>
              <span v-if="detailData.orderInfo" class="val" v-html="mapVehicle(detailData.orderInfo.vehicleType) + ' / ' + detailData.orderInfo.vehicleLength + 'm'"></span>
            </div>
            <div class="item">
              <span class="label">承运信息：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.carrierInfo || ''}}</span>
            </div>
          </div>
          <div class="itemGroup">
            <div class="item">
              <span class="label">承运车辆：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.vehicleSerial || ''}}</span>
            </div>
            <div class="item">
              <span class="label">实际发车时间：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.actualDepartTm || ''}}</span>
            </div>
            <div class="item">
              <span class="label">实际到车时间：</span>
              <span v-if="detailData.orderInfo" class="val">{{detailData.orderInfo.actualArriveTm || ''}}</span>
            </div>
          </div>
          <div class="lablepd">附件：</div>
          <div v-if="detailData.orderInfo" class="fileListCont">
            <div v-for="item in detailData.orderInfo.fileList" :key="item.ossUrl">
              <a style="text-decoration: none;" target="_blank" :href="formatImgUrl(item.ossUrl)" v-if="isMytypeimg(item.fileName)" class="item">
                <img :src="formatImgUrl(item.ossUrl)" alt="">
                <span>{{item.fileName}}</span>
              </a>
              <a style="text-decoration: none;" target="_blank" :href="formatFileUrl(item.ossUrl)" v-else class="item">
                <img src="../../../assets/pd.png" alt="">
                <span>{{item.fileName}}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="parttwo">
          <div class="title">流程进度</div>
          <el-table :data="detailData.opinionList" style="width: 100%">
            <el-table-column
              prop="taskName"
              label="任务名称"
            ></el-table-column>
            <el-table-column
              prop="endTimeStr"
              label="审批时间"
            ></el-table-column>
            <el-table-column
              prop="durTimeStr"
              label="持续时间"
            ></el-table-column>
            <el-table-column
              prop="userName"
              label="执行人"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.status === -1">{{ formatNameList(scope.row.nameList) }}</span>
                <span v-else>{{ scope.row.userName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="处理状态"
            >
              <template slot-scope="scope">
                <span>{{ formatDealStatu(scope.row.status) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="partthree">
          <div class="title">操作日志</div>
          <el-table :data="detailData.logList" style="width: 100%">
            <el-table-column
              label="操作类型"
            >
              <template slot-scope="scope">
                <span>{{ formatOpreatType(scope.row.logType) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作人"
            >
              <template slot-scope="scope">
                <span>{{ formatOpreatPeople(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="operateTm"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              prop="comment"
              label="备注"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetail=false" size="mini">取 消</el-button>
        <el-button type="primary" @click="showDetail=false" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 提交申请 -->
    <el-dialog
      title="提交申请"
      :visible.sync="showSubmit"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      style="width:1200px;margin:0 auto">
      <div class="title11">
        <span class="specl">上传附件（非必传）</span>
        <span>（最多上传10个，单个文件不超2M）</span>
      </div>
      <div class="title22">根据实际情况评估是否补充审核信息，如无需补充可直接提交审核</div>
      <div>
        <el-upload
          class="upload-demo"
          style="text-align:center;width:360px;margin:0 auto;"
          drag
          multiple
          :limit="10"
          :before-upload="beforeUpload"
          :http-request="upfile"
          :on-exceed="exceedWarn"
          :show-file-list="false"
          action=""
          accept=".doc, .docx, .pdf, .png, .jpg, .jpeg, .xlsx">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <span style="font-size:16px;color:rgba(0,0,0,0.85);line-height:24px;">点击或将文件拖拽到这里上传</span><br>
            <span style="font-size:14px;color:rgba(0,0,0,0.43);">支持扩展名： .doc .docx .pdf .excel .png .jpg .jpeg</span>
          </div>
        </el-upload>
        <div class="fileListCont">
          <div class="item" v-for="(item,index) in upFilelist" :key="item.ossUrl">
            <i class="el-icon-link icon"></i>
            <span class="filetext">{{item.fileName}}</span>
            <i class="el-icon-close iconr" @click="delectFile(index)"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="subApplicaSure" :loading="subApplicaLoading" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import getMvcUrl from "../../../utils/mvcUrlUtil.js";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      permissions: {
				owsp_abnormalProcess_query: false,    //查看
        owsp_abnormalProcess_submit: false,   //提交申请
        owsp_abnormalProcess_look: false      //查询
			},
      form: {
        orderId: '',
        outerOrderId: '',
        planDepartTm: [],
        planDepartTmStart: '',
        planDepartTmEnd: '',
        vehicleLenStr: '',
        carrierType: '',
        carrier: '',
        driverName: '',
        vehicleSerial: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      vehicleMap: [{
        "plVehicleType": "厢式",
        "plVehicleCode": "300",
        "grdVehicleCode": "002001"
      },{
        "plVehicleType": "平板",
        "plVehicleCode": "350",
        "grdVehicleCode": "002007"
      },{
        "plVehicleType": "高栏",
        "plVehicleCode": "450",
        "grdVehicleCode": "002024"
      },{
        "plVehicleType": "特种运输",
        "plVehicleCode": "600",
        "grdVehicleCode": "002025"
      },{
        "plVehicleType": "封闭式一体货车/客车",
        "plVehicleCode": "100",
        "grdVehicleCode": "002016"
      },{
        "plVehicleType": "冷藏车",
        "plVehicleCode": "900",
        "grdVehicleCode": "002013"
      }],
      showDetail: false,
      detailData: {},
      currentOrderId: '',
      subApplicaLoading: false,
      showSubmit: false,
      paramaFormdata: null,
      upFilelist: []
    };
  },
  created() {
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
  },
  mounted() {
    this.getTableData();
  },
  methods: {
     ...mapActions([
      "getTableApi",
      "processDetailApi",
      "uploadspefileApi",
      "subApplicationApi"
      ]),
    changeEvent(val) {},
    // 查询
    onSearch() {
      this.getTableData();
    },
    // 重置
    onReset() {
      this.form.orderId = ''
      this.form.outerOrderId = ''
      this.form.planDepartTm = []
      this.form.planDepartTmStart = ''
      this.form.planDepartTmEnd = ''
      this.form.vehicleLenStr = ''
      this.form.carrierType = ''
      this.form.carrier = ''
      this.form.driverName = ''
      this.form.vehicleSerial = ''
    },
    // 查看
    checkDetail(row) {
      let parama = {
        orderId: row.orderId
      }
      this.processDetailApi(parama)
        .then((res) => {
          this.detailData = res
          if(this.detailData.orderInfo.fileList) {
            this.detailData.orderInfo.fileList = eval(this.detailData.orderInfo.fileList)
          }
          this.showDetail = true
        })
        .catch((e) => {})
        .finally(() => {});
    },
    // 详情图片路径补全
    formatImgUrl(itemurl) {
      let murl = getMvcUrl() + "/saas/companyQualification/viewImage?objectName="+itemurl
      return murl
    },
    // 文件路径补全
    formatFileUrl(itemurl) {
      let murl = getMvcUrl() + "/saas/companyQualification/downLoadFile?objectName="+itemurl
      return murl
    },
    // 判断是否为图片文件  ['doc', 'docx', 'pdf', 'png', 'jpg', 'jpeg', 'xlsx']
    isMytypeimg(str) {
      if(str) {
        let arrImgType = ['png', 'jpg', 'jpeg']
        if(arrImgType.indexOf(str.split('.').pop().toLowerCase()) > -1){
          return true
        }
        return false
      }
    },
    // 提交申请框关闭
    handleClose() {
      this.showSubmit = false
      this.upFilelist = []
    },
    // 提交申请
    subApplication(row) {
      this.currentOrderId = row.orderId
      this.showSubmit = true
    },
    // 文件超出个数限制
    exceedWarn(files, fileList) {
      this.$message({
        message: '最多上传10个文件',
        type: 'warning'
      });
    },
    beforeUpload(file) {
      if(file) {
        const isLt2M = file.size / 1024 / 1024 <= 2
        if(isLt2M) {
          let formData = new window.FormData()
          formData.append('processFile',file)
          this.paramaFormdata = formData
        }else{
          this.$message({
            message: '文件大小不能超过2M',
            type: 'warning'
          });
          return false;
        }
      }
    },
    // 文件删除
    delectFile(index) {
      if(this.upFilelist.length > 0){
        this.upFilelist.splice(index, 1)
      }
    },
    // 文件上传
    upfile() {
      this.uploadspefileApi(this.paramaFormdata)
        .then((res) => {
          let obj = {}
          obj.fileName = res.originalFilename
          obj.ossUrl = res.fileName
          this.upFilelist.push(obj)
        })
        .catch((e) => {})
        .finally(() => {});
    },
    // 提交申请确定
    subApplicaSure() {
      this.subApplicaLoading = true
      let parama = {}
      parama.fileList = this.upFilelist
      parama.orderId = this.currentOrderId
      this.subApplicationApi(parama)
        .then((res) => {
          this.showSubmit = false
          this.getTableData()
        })
        .catch((e) => {})
        .finally(() => {
          this.subApplicaLoading = false;
        });
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true
      if(this.form.planDepartTm.length > 0) {
        this.form.planDepartTmStart = this.form.planDepartTm[0]
        this.form.planDepartTmEnd = this.form.planDepartTm[1]
      }
      this.getTableApi(this.form)
        .then((res) => {
          this.tableData = res.rows
          this.total = res.totalCount
        })
        .catch((e) => {})
        .finally(() => {
          this.tableLoading = false;
        });
    },
    onSizeChange() { },
    onCurrentChange(val) {
      this.form.pageNum = val;
      this.getTableData();
    },
    // 字段格式转换
    mapVehicle(code) {
      let name = ''
      this.vehicleMap.forEach(item => {
        code == item.plVehicleCode && (name = item.plVehicleType)
      })
      return name
    },
    lineList(row) {
      return '<span class="point src"></span>' + row.srcAddr + '<br><span class="point dest"></span>' + row.destAddr
    },
    mapFindCar(dispatchMode) {
      let res = '';
      switch (dispatchMode) {
        case 0: res = '指派用车'; break;
        case 1: res = '一口价找车'; break;
        case 2: res = '竞价找车'; break;
        case 3: res = '招标用车'; break;
        case -1: res = '询价用车'; break;
        default: res = ''; break;
      }
      return res;
    },
    formatDDState(val) {  //"待接单", 1 "待装货", 2 "运输中", 3 "收货中", 4 "已取消", 5 "已中止", 9 "已完成", 10 "待结算", 11
      let res = '';
      switch (val) {
        case 1: res = '待接单'; break;
        case 2: res = '待装货'; break;
        case 3: res = '运输中'; break;
        case 4: res = '收货中'; break;
        case 5: res = '已取消'; break;
        case 9: res = '已中止'; break;
        case 10: res = '已完成'; break;
        case 11: res = '待结算'; break;
        default: res = ''; break;
      }
      return res;
    },
    formatProcessState(val) { //状态: 0 待提交 1 审核中 2 审核通过 3 审核不通过
      let res = '';
      switch (val) {
        case 0: res = '待提交'; break;
        case 1: res = '审核中'; break;
        case 2: res = '审核通过'; break;
        case 3: res = '审核不通过'; break;
        default: res = ''; break;
      }
      return res;
    },
    formatOpreatType(val) { //类型: 0 记录生成 1 提交记录 2 审核通过 3.审核驳回
      let res = '';
      switch (val) {
        case 0: res = '记录生成'; break;
        case 1: res = '提交记录'; break;
        case 2: res = '审核通过'; break;
        case 3: res = '审核驳回'; break;
        default: res = ''; break;
      }
      return res;
    },
    formatOpreatPeople(row) {
      let str = ''
      if(row.operatorName){
        str += row.operatorName + ' '
      }
      if(row.operatorPhone) {
        str += row.operatorPhone
      }
      return str
    },
    formatNameList(arr) {
      let str = ''
      if(arr && arr.length > 0) {
        arr.forEach(item => {
          str = str+item+' ' 
        })
        return str
      }
      return str
    },
    formatDealStatu(val) {  //初始化\尚未审批=-2,正在审批=-1,弃权=0,同意=1,反对=2,驳回=3,追回=4,...终止=14,... 办结转发=16,撤销=17,逻辑删除=18,转办=21,转办取消=22,更改执行人=23,..代理=26,代理撤消=27,表单意见=28,驳回取消=29,撤销取消=30,通过取消=31,拒绝取消=32,提交=33,重新提交=34,干预=35,
      let res = '';
      switch (val) {
        case -2: res = '初始化\尚未审批'; break;
        case -1: res = '正在审批'; break;
        case 0: res = '弃权'; break;
        case 1: res = '同意'; break;
        case 2: res = '反对'; break;
        case 3: res = '驳回'; break;
        case 4: res = '追回'; break;
        case 14: res = '终止'; break;
        case 16: res = '办结转发'; break;
        case 17: res = '撤销'; break;
        case 18: res = '逻辑删除'; break;
        case 21: res = '转办'; break;
        case 22: res = '转办取消'; break;
        case 23: res = '更改执行人'; break;
        case 26: res = '代理'; break;
        case 27: res = '代理撤消'; break;
        case 28: res = '表单意见'; break;
        case 29: res = '驳回取消'; break;
        case 30: res = '撤销取消'; break;
        case 31: res = '通过取消'; break;
        case 32: res = '拒绝取消'; break;
        case 33: res = '提交'; break;
        case 34: res = '重新提交'; break;
        case 35: res = '干预'; break;
        default: res = ''; break;
      }
      return res;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-tag {
  padding: 0px 6px !important;
  margin: 2px !important;
}
.wraper {
  .title1 {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    font-weight: bold;
    padding: 20px 0 16px 48px !important;
    box-sizing: border-box !important;
    margin-bottom: 15px !important;
  }
  .selectWrap{
  }
}
.alertCont{
  padding: 24px;
  box-sizing: border-box;
  .partone {
    .title{
      font-size: 15px;
      color: #000000;
      font-weight: bold;
    }
    .itemGroup{
      margin-top: 16px !important;
      display: flex;
      .item{
        flex: 1;
        display: flex;
        padding: 0 5px !important;
        box-sizing: border-box !important;
        .label{
          font-size: 14px;
          color: rgba(0,0,0,0.65);
        }
        .val{
          flex: 1;
          font-size: 14px;
          color: #000000;
          font-weight: 500;
        }
      }
    }
    .lablepd{
      margin-top: 16px !important;
    }
    .fileListCont{
      margin-top: 6px !important;
      padding: 0 34px !important;
      box-sizing: border-box !important;
      display: flex;
      .item{
        width: 103px;
        margin: 0 14px !important;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: center;
        img {
          width: 100%;
          font-size: 0;
          margin-bottom: 12px !important;
        }
        span {
          display: block;
          width: 100%;
          font-size: 12px;
          color: rgba(0,0,0,0.65);
          text-align: center;
        }
      }
    }
  }
  .parttwo {
    margin-top: 46px !important;
    .title {
      margin-bottom: 16px !important;
      font-size: 15px;
      color: #000000;
      font-weight: bold;
    }
  }
  .partthree{
    margin-top: 46px !important;
    .title {
      margin-bottom: 16px !important;
      font-size: 15px;
      color: #000000;
      font-weight: bold;
    }
  }
}
.title11{
  text-align: center;
  font-size: 12px;
  color: #666666;
  line-height: 22px;
  .specl{
    font-size: 14px;
    color: #000000;
  }
}
.title22{
  text-align: center;
  font-size: 14px;
  color: #666666;
  margin-bottom: 16px !important;
}
.fileListCont{
  margin-top: 2px !important;
  .item{
    width: 360px;
    margin: 0 auto !important;
    margin-top: 8px !important;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    .icon{
      margin-right: 8px;
    }
    .filetext{
    }
    .iconr{
      margin-left: auto;
      &:hover{
        color: #000;
      }
    }
  }
}
</style>